import React, { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Date from "./DateRange";
import Locations from "./Locations";
import PersonTypes from "./PersonTypes";
import Packages from "./Packages";
import Activities from "./Activities";
import { validateMainStep } from "./validate";
import { mainRoute } from "./route";
import { Step, validateFromTo } from "../stepsStore";
import { AppConfig } from "../../config";
import { useStore } from "effector-react";
import { $selectedLocation } from "../../store/selected/selectedLocations";

export const mainStep: Step = {
  order: 0,
  tKey: "main",
  validate: validateMainStep,
  route: mainRoute,
};

const MainStep: FC = () => {
  const { t } = useTranslation(AppConfig.translationFileNames.step_Main);

  useEffect(() => {
    validateFromTo(mainStep.order, mainStep.order, true, false);
  }, []);

  const componentsForOrder = {
    activities: Activities,
    packages: Packages,
  };
  const selectedLocation = useStore($selectedLocation);
  const sections_sequence =
    selectedLocation?.sections_sequence ?? AppConfig.sections_sequence;

  return (
    <>
      <h1>{t("Title")}</h1>

      <Date />

      <Locations />

      <PersonTypes />

      {sections_sequence.map((key) =>
        React.createElement((componentsForOrder as any)[key])
      )}
    </>
  );
};

export default MainStep;
